import { render } from "./ConfirmDialogTwoButtons.vue?vue&type=template&id=07760c2d"
import script from "./ConfirmDialogTwoButtons.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogTwoButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__